import React from 'react';

import { ReturnComponentType } from 'common';

import './TableSkeleton.scss';

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
  columnTemplate?: string;
}

export const TableSkeleton = ({
  rows = 5,
  columns = 4,
  columnTemplate = '1fr 1fr 1fr 1fr',
}: TableSkeletonProps): ReturnComponentType => {
  return (
    <div className="TableSkeleton">
      {Array.from({ length: rows }, (_, rowIndex) => (
        <div
          key={rowIndex}
          className="TableSkeleton_Row"
          style={{ gridTemplateColumns: columnTemplate }}
        >
          {Array.from({ length: columns }, (_, colIndex) => (
            <div key={colIndex} className="TableSkeleton_Cell" />
          ))}
        </div>
      ))}
    </div>
  );
};
